import { ReactNode } from "react"
import { FusionColor } from "../../../theme/FusionStyle"
import { V2L1ReasonableButtonRoot } from "./V2L1ReasonableButton"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faBug } from '@fortawesome/pro-solid-svg-icons'

interface V2L1AppHeaderFeatureButtonProps {
	icon?: IconProp
	children?: ReactNode
	active?: boolean
	onClick?: () => void
}

export const V2L1AppHeaderFeatureButton = ({icon, children, active, onClick}: V2L1AppHeaderFeatureButtonProps) => {
	return (
		<V2L1ReasonableButtonRoot
			color={active ? FusionColor.BlueMain : FusionColor.White}
			loading={false}
			hasLabel={false}
			onClick={onClick}
		>
			{children ?? (
				<FontAwesomeIcon
					icon={icon ?? faBug}
					fixedWidth
				/>
			)}
		</V2L1ReasonableButtonRoot>
	)
}
